import { alpha, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'tests-expanded',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      padding: theme.spacing(1, 2),
    },
    list: {},
    listItem: {
      borderRadius: 4,
      padding: theme.spacing(1),
      '&:nth-child(odd)': {
        backgroundColor: alpha(theme.palette.primary.main, 0.05),
      },
    },
    workHistoryContainer: {
      borderRadius: 4,
      backgroundColor: alpha(theme.palette.primary.main, 0.05),
      '& $listItem': {
        backgroundColor: 'transparent',
      },
    },
  }),
  options
);

export default useStyles;
